import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import Select from 'react-select';

export default class CompetitionDraftReviewersComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            reviewers: window.reviewers || [],
            selectedReviewers: window.selectedReviewers || [],
        };

        this.onReviewersChange = this.onReviewersChange.bind(this);
    }

    onReviewersChange(selectedReviewers) {
        this.setState({selectedReviewers});
    }

    render() {
        return (
            <div className="form-group">
                <label htmlFor="reviewer_ids" className="control-label view-label">
                    {window.__js_bid_reviews.competition_draft_to_review_by}
                </label>

                <div className="view-data">
                    <Select name="reviewer_ids[]"
                            id="reviewer_ids"
                            multi={true}
                            placeholder={window.__js_bid_reviews.select_reviewers}
                            value={this.state.selectedReviewers}
                            options={this.state.reviewers}
                            onChange={this.onReviewersChange}/>
                </div>
            </div>
        );
    }
}

const element = document.getElementById('competition-draft-reviewers-component');

if (element) {
    ReactDOM.render(
        <CompetitionDraftReviewersComponent/>,
        element
    );
}